import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attachment-item"
export default class extends Controller {
  static values = { attachmentId: String }

  remove(event) {
    // Stop event propagation to prevent triggering download link
    event.stopPropagation()
    event.preventDefault()

    // Get the attachment ID from the data attribute
    const attachmentId = this.attachmentIdValue

    // Remove all elements with the same attachment class
    if (attachmentId) {
      document.querySelectorAll(`.attachment_${attachmentId}`).forEach((el) => el.remove())
    }
  }
}
